export const sizes = ["sm", "md", "lg"];
export const variants = ["outline", "primary", "text"];
export const DEFAULT_SIZE = "md";
export const DEFAULT_VARIANT = "outline";
export const DEFAULT_ELEMENT_TYPE = "button";
